import Titulo from '../../components/tipografia/Titulo';
import React, { useCallback, useState } from 'react';
import styles from './page.module.css';
import LayoutUsuario from '../../components/navegacao/LayoutUsuario';
import Descricao from '../../components/tipografia/Descricao';
import HBox from '../../components/layout/HBox';
import Botao from '../../components/Botao';
import VBox from '../../components/layout/VBox';
import Icon from '../../components/Icon';
import {
  mdiEye,
  mdiLoading,
  mdiPlus,
  mdiSync,
  mdiAlertCircle,
  mdiInformation,
  mdiLightbulb,
} from '@mdi/js';
import DataTable, { DataTableHeader } from '../../components/layout/DataTable';
import { useInfiniteQuery, useMutation, useQuery } from 'react-query';
import axios from 'axios';
import { useDebounce } from '../chat/useDebounce';
import { toast } from 'react-toastify';
import Modal from '../../components/layout/Modal';
import { FiltroCanais } from '../historico_mensagens/FiltroCanais';
import Grid, { GridItem } from '../../components/layout/Grid';
import { parseISO, format } from 'date-fns';
import { FormCampanha } from './FormCampanha';
import { Tutorial } from '@/components/Tutorial';
import { TutoriaisKeys } from '@tera/shared/src/tutoriais/constants';
import { useNavigate } from 'react-router-dom';
import FreeTierModal from '@/components/FreeTierModal';

type ResponseList = {
  status: number;
  ok?: boolean;
  result: any[];
  total: number;
  cursor: string | number | null;
};

type Props = {};

const Page = ({ }: Props) => {
  const [editObject, setEditObject] = React.useState<any>(null);
  const [fieldErrors, setFieldErrors] = React.useState<Record<
    string,
    string
  > | null>(null);
  const navigate = useNavigate();

  const [search, setSearch] = React.useState<string>('');
  const debouncedSearch = useDebounce(search, 500);
  const [importCompleted, setImportCompleted] = useState(false);
  const [showModalRetry, setShowModalRetry] = useState(false);
  const [selectedEventos, setSelectedEventos] = useState<any>(null);
  const [showModalEventos, setShowModalEventos] = useState(false);
  const [showFreeTierModal, setShowFreeTierModal] = useState(false);

  const [filterCanais, setFilterCanais] = React.useState<string[]>([]);

  // Buscar capacidades do plano
  const capacidadesQuery = useQuery(
    ['capacidades'],
    async () => {
      const res = await axios.get('/api/capacidades', {
        withCredentials: true,
      });
      return res.data;
    },
    {
      refetchOnWindowFocus: false,
      staleTime: 30000, // 30 segundos
    }
  );

  const headers: DataTableHeader[] = [
    { label: 'Código', width: '10%', column: 'id' },
    {
      label: 'Data criação',
      width: '15%',
      render: (row: any) => (
        <span>{format(parseISO(row.data_criacao), 'dd/MM/yyyy HH:mm')}</span>
      ),
    },
    {
      label: 'Canal associado',
      width: '50%',
      render: row => <span>{row.canal?.nome ?? row.canal_nome}</span>,
    },
    {
      label: 'Q. contatos',
      width: '10%',
      column: 'qtd_clientes',
    },
    {
      label: 'Estado atual',
      alignCenter: true,
      width: '15%',
      render: (row: any) => {
        const progresso = campanhaProgressQuery.data?.result?.find(
          (it: any) => it.id === row.id,
        );

        const totais = progresso
          ? {
            convertidos: progresso.qtd_convertidos ?? 0,
            enviados: progresso.qtd_sucessos ?? 0,
            erros: progresso.qtd_erros ?? 0,
            naoProcessados:
              progresso.qtd_clientes -
              (progresso.qtd_convertidos ?? 0) -
              (progresso.qtd_sucessos ?? 0) -
              (progresso.qtd_erros ?? 0) -
              (progresso.qtd_nao_enviados ?? 0),
            naoEnviados: progresso.qtd_nao_enviados ?? 0,
            total: progresso.qtd_clientes,
          }
          : {
            convertidos: row.qtd_convertidos ?? 0,
            enviados: row.qtd_sucessos ?? 0,
            erros: row.qtd_erros ?? 0,
            naoProcessados:
              row.qtd_clientes - (row.qtd_convertidos ?? 0) - (row.qtd_sucessos ?? 0) - (row.qtd_erros ?? 0) - (row.qtd_nao_enviados ?? 0),
            naoEnviados: row.qtd_nao_enviados ?? 0,
            total: row.qtd_clientes,
          };

        const percs = {
          convertidos:
            totais.total === 0
              ? 0
              : Math.round((totais.convertidos * 100.0) / totais.total),
          enviados:
            totais.total === 0
              ? 0
              : Math.round((totais.enviados * 100.0) / totais.total),
          erros:
            totais.total === 0
              ? 0
              : Math.round((totais.erros * 100.0) / totais.total),
          naoProcessados:
            totais.total === 0
              ? 0
              : Math.round((totais.naoProcessados * 100.0) / totais.total),
          naoEnviados:
            totais.total === 0
              ? 0
              : Math.round((totais.naoEnviados * 100.0) / totais.total),
        };

        return (
          <div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                gap: '0.5rem',
                alignItems: 'center',
                justifyContent: 'center',
                height: '20px',
                borderLeft: progresso
                  ? '1px solid var(--tc-color-success)'
                  : undefined,
              }}
            >
              <div
                style={{
                  width: '48px',
                  height: '0.5rem',
                  borderRadius: '0.25rem',
                  overflow: 'hidden',
                  display: 'flex',
                  flexDirection: 'row',
                }}
              >
                <div
                  style={{
                    width: `${percs.convertidos}%`,
                    height: '100%',
                    backgroundColor: 'var(--tc-color-success)',
                  }}
                  title={`${percs.convertidos}% convertidos`}
                ></div>
                <div
                  style={{
                    width: `${percs.enviados}%`,
                    height: '100%',
                    backgroundColor: 'var(--tc-color-info-500)',
                  }}
                  title={`${percs.enviados}% enviados`}
                ></div>
                <div
                  style={{
                    width: `${percs.erros}%`,
                    height: '100%',
                    backgroundColor: 'var(--tc-color-danger)',
                  }}
                  title={`${percs.erros}% com erro no processamento`}
                ></div>
                <div
                  style={{
                    width: `${percs.naoProcessados}%`,
                    height: '100%',
                    backgroundColor: 'var(--tc-color-gray-500)',
                  }}
                  title={`${percs.naoProcessados}% em processamento / não processados`}
                ></div>
                <div
                  style={{
                    width: `${percs.naoEnviados}%`,
                    height: '100%',
                    backgroundColor: 'var(--tc-color-warning)',
                  }}
                  title={`${percs.naoEnviados}% não enviados`}
                ></div>
              </div>
            </div>
            <div
              style={{
                fontSize: '12px',
                color: 'var(--tc-color-gray-400)',
              }}
            >
              {row.estado === 'agendada' && row.data_agendamento
                ? `agendada p/ ${format(parseISO(row.data_agendamento), 'dd/MM/yyyy HH:mm')}`
                : row.estado}
            </div>
          </div>
        );
      },
    },
    {
      label: 'Eventos',
      width: '80px',
      alignCenter: true,
      render: (row: any) => {
        const hasEventos = row.eventos && row.eventos.length > 0;
        if (!hasEventos) return null;

        const tipoEvento = row.eventos[0]?.tipo;
        const iconMap = {
          erro: { path: mdiAlertCircle, color: 'var(--tc-color-danger)' },
          aviso: { path: mdiInformation, color: 'var(--tc-color-warning)' },
          dica: { path: mdiLightbulb, color: 'var(--tc-color-primary)' },
        };

        const iconData = iconMap[tipoEvento as keyof typeof iconMap] || iconMap.dica;

        return (
          <div
            style={{ cursor: 'pointer' }}
            onClick={() => {
              setSelectedEventos(row.eventos);
              setShowModalEventos(true);
            }}
            title={`${row.eventos.length} evento(s)`}
          >
            <Icon path={iconData.path} size={1} color={iconData.color} />
          </div>
        );
      },
    },
    {
      label: 'Ações',
      width: '100px',
      stickRight: true,
      alignRight: true,
      render: (row: any) => {
        return (
          <HBox gap="8px" style={{ justifyContent: 'flex-end' }}>
            {['concluida', 'erro'].includes(row.estado) &&
              (row.qtd_erros > 0 ||
                (row.qtd_clientes > 0 && row.qtd_sucessos == 0 && row.qtd_convertidos == 0)) && (
                <Botao
                  variant="none-primary"
                  icon={mdiSync}
                  onClick={() => {
                    retryMutator.mutate({ id: row.id });
                  }}
                />
              )}
            <Botao
              variant="none-info"
              icon={mdiEye}
              onClick={() => {
                navigate(`/campanha_mensagem/${row.id}/mensagens`);
              }}
              title="Visualizar mensagens"
            />
          </HBox>
        );
      },
    },
  ];

  const campanhaProgressQuery = useQuery(
    ['campanha_mensagem_progress'],
    async () => {
      const res = await fetch('/api/campanha_mensagem/progress');
      return res.json();
    },
    {
      staleTime: 20000,
      refetchInterval: data => {
        if (!data || data.result.length === 0) {
          return 10000;
        }
        return 2000;
      },
      onSuccess: data => {
        if (!data) return;

        for (const res of data.result) {
          if (['concluida', 'erro'].includes(res.estado)) {
            console.log('campanha ' + res.id + ' concluída');
            queryList.refetch();
            return;
          }
        }
      },
    },
  );

  const queryList = useInfiniteQuery({
    queryKey: ['campanha_mensagem'],
    queryFn: async ({ pageParam }) => {
      const where: Record<string, any> = {};

      if (filterCanais.length > 0) {
        where['canal.id'] = ['in', filterCanais];
      }

      const params = new URLSearchParams({
        txt: search,
        c: pageParam,
        fi: JSON.stringify(where),
      });

      return await axios.get<ResponseList>(
        `/api/campanha_mensagem?${params.toString()}`,
        {
          withCredentials: true,
        },
      );
    },
    getNextPageParam: lastPage => lastPage.data.cursor ?? undefined,
  });

  const canalQuery = useQuery(['canal'], async () => {
    const res = await fetch('/api/canal/box');
    return res.json();
  });

  const msgProgramadaQuery = useQuery(['mensagem_programada'], async () => {
    const res = await fetch('/api/mensagem_programada/box');
    return res.json();
  });

  const handleChange = useCallback(async () => { }, []);

  const handleCloseModal = () => {
    setEditObject(null);
    setFieldErrors(null);
  };

  const handleOpenModalNewObject = () => {
    // Verificar se está no plano free tier
    if (capacidadesQuery.data?.freeTier) {
      setShowFreeTierModal(true);
      return;
    }

    setImportCompleted(false);
    setEditObject({});
  };

  const handleCampanhaCompleted = () => {
    // setNewObj(null)
    setImportCompleted(true);
    console.log('handleCampanhaCompleted');
    queryList.refetch();

    setEditObject(null);
    toast('A campanha foi iniciada com sucesso!', {
      toastId: 'success',
      position: 'top-center',
      type: 'success',
      autoClose: 5000,
    });
  };

  const handleCampanhaError = () => {
    setImportCompleted(true);
    console.log('handleCampanhaError');
    queryList.refetch();

    setEditObject(null);
    toast('Ocorreu um erro ao tentar iniciar a campanha. Tente novamente mais tarde.', {
      toastId: 'warning',
      position: 'top-center',
      type: 'warning',
      autoClose: 5000,
    });
  };

  const retryMutator = useMutation(
    (data: any) => {
      setShowModalRetry(true);
      return fetch(`/api/campanha_mensagem/${data.id}/retry_failed`, {
        method: 'POST',
      }).then(res => res.json());
    },
    {
      onSettled: () => {
        queryList.refetch();
        retryMutator.reset();
      },
    },
  );

  const execute = async (data: any) => { };

  const queryFlatList =
    queryList.data?.pages?.map(p => p.data.result)?.flat() ?? [];
  const total =
    queryList.data?.pages?.[queryList.data.pages.length - 1]?.data?.total ?? 0;
  const editMode = !!editObject?.id && editObject.id > 0;

  return (
    <LayoutUsuario>
      <FreeTierModal
        show={showFreeTierModal}
        onClose={() => setShowFreeTierModal(false)}
        feature="o envio de campanhas em massa"
      />

      <Modal
        title="Executando campanha"
        show={showModalRetry}
        onClose={() => setShowModalRetry(false)}
        onConfirm={() => setShowModalRetry(false)}
      >
        <p>Sua solicitação agora está sendo processada.</p>
        <p>Acompanhe o progresso na tela de campanhas.</p>
      </Modal>

      <Modal
        instanceId='modal-campanha'
        title="Nova campanha"
        show={editObject != null}
        onClose={() => setEditObject(null)}
        hideControls
        ignoreOverlayClick
      >
        <form
          onSubmit={e => {
            e.preventDefault();
            execute(editObject);
          }}
        >
          <FormCampanha onCompleted={handleCampanhaCompleted} onError={handleCampanhaError} />
        </form>
      </Modal>

      <VBox gap="16px" style={{ height: 'calc(100vh - 32px)' }}>
        {/* Header */}
        <Grid>
          <GridItem sm={12} md={4}>
            <VBox style={{ flex: 1 }}>
              <Titulo>Campanhas</Titulo>
              <Descricao>
                Dispare notificações em massa para seus clientes.
              </Descricao>
            </VBox>
          </GridItem>
          <GridItem sm={12} md={4}>

            <div style={{ flex: 1, textAlign: 'center' }}>
              <Tutorial id={TutoriaisKeys.CAMPANHA_MENSAGEM} />
            </div>
          </GridItem>
          <GridItem sm={12} md={4}>

            <HBox gap="12px" className={styles.headerAcoes} style={{ flex: 1 }}>
              <div>
                <Botao
                  variant="primary"
                  icon={mdiPlus}
                  onClick={handleOpenModalNewObject}
                >
                  Nova
                </Botao>
                {capacidadesQuery.data?.freeTier && (
                  <div
                    style={{
                      marginLeft: '8px',
                      fontSize: '12px',
                      fontStyle: 'italic',
                      color: 'var(--tc-color-danger)',
                      textAlign: 'center',
                    }}
                  >
                    Plano gratuito
                  </div>
                )}
              </div>
            </HBox>
          </GridItem>
        </Grid>

        <Grid>
          <GridItem sm={12}>
            <FiltroCanais value={filterCanais} onChange={setFilterCanais} />
          </GridItem>
        </Grid>

        <div>
          <Botao variant="primary" onClick={() => queryList.refetch()}>
            Aplicar
          </Botao>
        </div>

        {queryList.isFetching && (
          <div>
            Aguarde...{' '}
            <Icon
              path={mdiLoading}
              size={0.8}
              color="var(--tc-color-gray-700)"
              spin
            />
          </div>
        )}
        {!queryList.isFetching && (
          <div>
            Exibindo {queryFlatList?.length ?? '0'} de {total ?? '0'}{' '}
            resultados.
          </div>
        )}

        <DataTable
          isLoading={queryList.isFetching}
          cabecalhos={headers}
          linhas={queryFlatList ?? []}
          hasMoreData={queryList.hasNextPage}
          onLoadMore={async () => queryList.fetchNextPage()}
        />
      </VBox>

      {/* Modal de Eventos */}
      <Modal
        show={showModalEventos}
        onClose={() => setShowModalEventos(false)}
        title="Eventos da Campanha"
        hideControls={true}
      >
        <VBox gap="16px" style={{ minWidth: '500px', maxWidth: '700px' }}>
          {selectedEventos && selectedEventos.length > 0 ? (
            selectedEventos.map((evento: any, index: number) => {
              const iconMap = {
                erro: { path: mdiAlertCircle, color: 'var(--tc-color-danger)', label: 'Erro' },
                aviso: { path: mdiInformation, color: 'var(--tc-color-warning)', label: 'Aviso' },
                dica: { path: mdiLightbulb, color: 'var(--tc-color-info)', label: 'Dica' },
              };
              const iconData = iconMap[evento.tipo as keyof typeof iconMap] || iconMap.dica;

              return (
                <div
                  key={evento.id || index}
                  style={{
                    padding: '16px',
                    border: `1px solid ${iconData.color}`,
                    borderRadius: '8px',
                    backgroundColor: 'var(--tc-color-gray-50)',
                  }}
                >
                  <HBox gap="12px" style={{ marginBottom: '12px', alignItems: 'center' }}>
                    <Icon path={iconData.path} size={1.2} color={iconData.color} />
                    <VBox gap="4px" style={{ flex: 1 }}>
                      <strong style={{ color: iconData.color }}>{iconData.label}</strong>
                      <span style={{ fontSize: '14px', color: 'var(--tc-color-gray-600)' }}>
                        {evento.metadados?.titulo || evento.evento.replace(/_/g, ' ')}
                      </span>
                    </VBox>
                    <span style={{ fontSize: '12px', color: 'var(--tc-color-gray-500)' }}>
                      {evento.data_criacao
                        ? format(parseISO(evento.data_criacao), 'dd/MM/yyyy HH:mm')
                        : ''}
                    </span>
                  </HBox>
                  {evento.sugestao_ia && (
                    <div
                      style={{
                        padding: '12px',
                        backgroundColor: 'white',
                        borderRadius: '4px',
                        fontSize: '14px',
                        lineHeight: '1.6',
                        whiteSpace: 'pre-wrap',
                      }}
                    >
                      {evento.sugestao_ia}
                    </div>
                  )}
                  {evento.metadados && Object.keys(evento.metadados).length > 0 && (
                    <div style={{ marginTop: '8px', fontSize: '12px', color: 'var(--tc-color-gray-600)' }}>
                      {Object.entries(evento.metadados).map(([key, value]) => (
                        <div key={key}>
                          <strong>{key}:</strong> {String(value)}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              );
            })
          ) : (
            <p>Nenhum evento encontrado.</p>
          )}
        </VBox>
      </Modal>
    </LayoutUsuario>
  );
};

export default Page;
